import { render, staticRenderFns } from "./userVip.vue?vue&type=template&id=08840bf7&scoped=true"
import script from "./userVip.vue?vue&type=script&lang=js"
export * from "./userVip.vue?vue&type=script&lang=js"
import style0 from "./userVip.vue?vue&type=style&index=0&id=08840bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08840bf7",
  null
  
)

export default component.exports